import { List } from 'antd'

import Link from '~/core/Link'
import Text from '~/core/Text'

import { SUB_MENU_LINKS } from './constants'

import { PLACEMENT } from '.'

const renderCard = ({ name, link }: { name: string; link: string }) => (
    <List.Item
        style={{
            alignItems: 'center',
            display: 'flex',
            padding: '32px 0px',
            justifyContent: 'between',
        }}
    >
        <Text>{name}</Text>
        <Link href={link} target="_blank" name={name} placement={PLACEMENT}>
            Learn more
        </Link>
    </List.Item>
)

export default function SubMenu() {
    return (
        <List
            itemLayout="horizontal"
            dataSource={SUB_MENU_LINKS}
            renderItem={renderCard}
            style={{ margin: '0px 32px' }}
        />
    )
}
